import styled from 'styled-components';

export const StyledSvg = styled.svg`
  max-width: 100%;
`;
